var map = {
	"./af.json": 79636,
	"./am.json": 51913,
	"./ar.json": 64725,
	"./az.json": 63026,
	"./be.json": 61070,
	"./bg.json": 17098,
	"./bn.json": 36117,
	"./br.json": 90093,
	"./bs.json": 13321,
	"./ca.json": 97326,
	"./cs.json": 70747,
	"./cy.json": 2706,
	"./da.json": 1957,
	"./de.json": 28470,
	"./dv.json": 78952,
	"./el.json": 70700,
	"./en.json": 66142,
	"./es.json": 58570,
	"./et.json": 11670,
	"./eu.json": 83017,
	"./fa.json": 23025,
	"./fi.json": 60586,
	"./fr.json": 47346,
	"./ga.json": 25614,
	"./gl.json": 83076,
	"./ha.json": 3845,
	"./he.json": 41188,
	"./hi.json": 79747,
	"./hr.json": 61150,
	"./hu.json": 81795,
	"./hy.json": 31355,
	"./id.json": 39958,
	"./is.json": 69192,
	"./it.json": 36640,
	"./ja.json": 5461,
	"./ka.json": 92014,
	"./kk.json": 91117,
	"./km.json": 37801,
	"./ko.json": 45110,
	"./ku.json": 45952,
	"./ky.json": 97523,
	"./lt.json": 16330,
	"./lv.json": 50179,
	"./mk.json": 99681,
	"./ml.json": 2482,
	"./mn.json": 39292,
	"./mr.json": 25817,
	"./ms.json": 79383,
	"./mt.json": 71196,
	"./nb.json": 37715,
	"./nl.json": 74231,
	"./nn.json": 85654,
	"./no.json": 10750,
	"./pl.json": 31634,
	"./ps.json": 57972,
	"./pt.json": 9962,
	"./ro.json": 56700,
	"./ru.json": 93330,
	"./sd.json": 59729,
	"./sk.json": 79391,
	"./sl.json": 87862,
	"./so.json": 87365,
	"./sq.json": 54545,
	"./sr.json": 66047,
	"./sv.json": 26461,
	"./sw.json": 16494,
	"./ta.json": 23512,
	"./tg.json": 27566,
	"./th.json": 36813,
	"./tk.json": 1823,
	"./tr.json": 28010,
	"./tt.json": 79439,
	"./ug.json": 91752,
	"./uk.json": 18572,
	"./ur.json": 92801,
	"./uz.json": 14805,
	"./vi.json": 10017,
	"./zh.json": 45179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7593;